import { Box, Drawer, Stack } from "@mui/material";
// components
import LinksDrawer from "./LinksDrawer";
import AppLogo from "./AppLogo";
import { sidebarWidth } from "../../theme/tokens";

type Props = {
  mobileOpen: boolean;
  onClose: () => void;
};

// Pure nav chrome now — the app bar / menu toggle lives in TopBar, and open
// state is owned by MainLayout so both can share it. The old hardcoded
// SlideProps={{ direction: "left" }} on both Drawers was compensating for
// theme.direction being "ltr" while the layout was actually RTL; now that the
// theme says "rtl" (see MuiTheme.tsx), MUI derives the correct slide
// direction on its own.
const SideDrawer = ({ mobileOpen, onClose }: Props) => {
  const drawerContent = (
    <Stack sx={{ height: "100%" }}>
      <AppLogo />
      <Box sx={{ flex: 1, overflowY: "auto", bgcolor: "background.paper" }}>
        <LinksDrawer onNavigate={onClose} />
      </Box>
    </Stack>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: sidebarWidth }, flexShrink: { md: 0 } }}
      aria-label="القائمة الجانبية"
    >
      {/* temporary drawer for small screens */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: sidebarWidth,
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* permanent drawer for large screens */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: sidebarWidth,
          },
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default SideDrawer;
